import script from "./ResourceStorage.vue?vue&type=script&lang=ts&name=ResourceStorage&setup=true"
export * from "./ResourceStorage.vue?vue&type=script&lang=ts&name=ResourceStorage&setup=true"

import "./ResourceStorage.vue?vue&type=style&index=0&id=767f83fc&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-767f83fc"]])

export default __exports__